import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <div className="mb-0 w-full h-40 bg-gray-900 text-white font-sans text-center p-3 footer-div">
            <h2 className="text-xl font-medium p-2">Gurukul Academy Bangladesh</h2>
            <h2 className="text-sm font-medium p-1">Mirpur 11, Dhaka 1216</h2>
            <h2 className="text-sm font-medium p-1">019XXX44498</h2>
            <p className="text-sm font-semibold italic p-2">@all rights reserved to shudipto 2021</p>

        </div>
    );
};

export default Footer;